export enum TipoCobroEnum {
    'Targeta',
    'Metàl·lic'
}